import React from "react";
import {
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter
} from "reactstrap";

const CancelModal = ({ modal, setModal, goBackHandler }) => {
    return (
        <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader>
                Alert
              </ModalHeader>
            <ModalBody>
                Careful you've entered new data on this page, if you navigate away without saving first, all changes will be lost.
              </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
                <button
                    className="btn btn-light px-3"
                    onClick={() => setModal(false)}
                >
                    Cancel
                </button>
                <button
                    className="btn btn-primary"
                    onClick={goBackHandler}
                >
                    Go Back
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default CancelModal